<template>
  <v-app>
    <v-layout row>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="project mt-2">
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat class="white--text" @click="editProjectPage()">
              Edit project
            </v-btn>
            <v-btn
              flat
              class="white--text"
              v-if="getProjectType() == 2"
              @click="locationPage()"
            >
              Edit Location
            </v-btn>
            <v-btn flat class="white--text" @click="editQuestion()">
              Edit Question
            </v-btn>
            <v-btn flat class="white--text" @click="assignTeamToProject()">
              Edit Assign Team To Project
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="white"
        :top="y === 'top'"
        class="black--text"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout row>
      <!-- comment layout  -->
      <v-flex xs12 sm3>
        <Comment />
      </v-flex>
      <v-flex xs12 sm9>
        <v-container grid-list-md>
          <v-card class="grey lighten-3">
            <v-card-title class="project">
              <div class="headline">Edit Budget</div>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Minimum Per Survey Cost</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-subheader class="black--text">
                      {{ getMin_per_survey_cost() }} Tk
                    </v-subheader>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Total Budget</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      @focus="totalBudget"
                      v-model="budget.total_budget_amount"
                      :value="total"
                      type="number"
                      label="Amount"
                      prefix="Tk"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Per Survey Cost</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="budget.per_survey_cost"
                      label="Amount"
                      type="number"
                      prefix="Tk"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Total Response</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      @focus="totalResponse"
                      v-model="budget.number_of_response"
                      :value="total"
                      :rules="totalResponseRules"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Vat (+5%)</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-subheader class="black--text">
                      {{ vat() }} Tk
                    </v-subheader>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs4>
                    <v-subheader>Grand Total</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <v-subheader class="black--text">
                      {{ grandTotal() }} Tk
                    </v-subheader>
                  </v-flex>
                </v-layout> -->
              </v-form>
            </v-card-text>

            <v-card-actions>
              <button class="button" flat @click="back">Back</button>
              <v-spacer></v-spacer>
              <v-btn class="button" flat @click="submit">Preview</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import router from "@/router";
  import Comment from "./Comment";

  export default {
    components: {
      Comment,
    },
    data: () => ({
      apiUrl: "project-info",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      editedIndex: -1,
      defaultItem: {
        total_budget_amount: 0,
        per_survey_cost: 0,
        number_of_response: 0,
        project_id: null,
        vat: 0,
        grand_total: 0,
      },
      budget: {
        total_budget_amount: 0,
        per_survey_cost: 0,
        number_of_response: 0,
        project_id: null,
        vat: 0,
        grand_total: 0,
      },
      val: "",
      minimum_survey_cost: 0,
      result: 0,

      valid: true,
      totalBudgetRules: [
        (v) => v > 0 || "This value must be greater than zero.",
      ],
      totalResponseRules: [
        (v) =>
          Number.isInteger(Number(v)) || "The value must be an integer number",
      ],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),

      total: function () {
        return this.calculationMethod(this.val);
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        var project_id_modify = JSON.parse(
          localStorage.getItem("project_id_modify")
        );
        this.budget.project_id = project_id_modify;
        this.$store.dispatch("indexData", [this.apiUrl, project_id_modify]);
      },

      getProjectType() {
        if (this.indexData.project_data) {
          if (this.indexData.project_data.project_type_id) {
            return this.indexData.project_data.project_type_id;
          }
        }
        return false;
      },

      editProjectPage() {
        router.push("/edit-project");
      },

      editQuestion() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-question",
        ]);
      },

      assignTeamToProject() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-dasher-category",
          project_id,
          "/edit-assign-teams-to-Project",
        ]);
      },

      locationPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "response-location",
          project_id,
          "/edit-address",
        ]);
      },
      totalBudget() {
        this.val = 1;
      },
      totalResponse() {
        this.val = 2;
      },

      close() {
        setTimeout(() => {
          this.budget = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      calculationMethod(valueFrom) {
        if (valueFrom == 1) {
          let calculatedTotal =
            this.budget.total_budget_amount / this.budget.per_survey_cost;
          this.budget.number_of_response = calculatedTotal;

          return calculatedTotal;
        }
        if (valueFrom == 2) {
          let budgetTotal =
            this.budget.number_of_response * this.budget.per_survey_cost;
          this.budget.total_budget_amount = budgetTotal;

          return budgetTotal;
        }
      },

      getMin_per_survey_cost() {
        if (this.indexData.project_data) {
          var question_data_json = JSON.parse(
            this.indexData.project_data.project_question_json
          );
          this.minimum_question_price = question_data_json.total_category_price;
          this.minimum_survey_cost = this.indexData.projectType[1].min_price;
          this.result = Math.max(
            Number(this.minimum_survey_cost),
            Number(this.minimum_question_price)
          );
        }
        return this.result;
      },

      vat() {
        let vat = (5 * this.budget.total_budget_amount) / 100;
        this.budget.vat = vat;
        return vat;
      },
      grandTotal() {
        let total = this.budget.total_budget_amount + this.budget.vat;
        this.budget.grand_total = total;
        return total;
      },

      back() {
        localStorage.setItem("EditBudgetObject", JSON.stringify(this.budget));

        router.push("/edit-question");
      },
      submit() {
        if (
          this.getProjectType() == 3 ||
          this.budget.per_survey_cost >= this.minimum_survey_cost
        ) {
          if (Number.isInteger(Number(this.budget.per_survey_cost))) {
            if (this.$refs.form.validate()) {
              var project_id_modify = JSON.parse(
                localStorage.getItem("project_id_modify")
              );
              this.budget.project_id = project_id_modify;
              this.$store.dispatch("storeOrUpdateBudgetModify", [
                "project-budget-modify",
                this.budget,
              ]);
              this.snackbar = true;
              this.close();
            }
          } else {
            alert("Per survey cost must be an integer value!");
          }
        } else {
          alert(
            "Per survey cost must be " +
              this.minimum_survey_cost +
              " or greater than!"
          );
        }
      },
    },
  };
</script>

<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 20px;
    cursor: pointer;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .headline {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }
</style>
